var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"how-to-use-image",attrs:{"to":"/ALIS-official/articles/3reY5BgBEZ8B"}})}
var staticRenderFns = []

export { render, staticRenderFns }